import axios from 'axios'
import ApiIntegrface from './api'
import config from '@/config.js'

export const REPORTS_PAGE_SIZE = 20

export function createReport(payload, callback, errhandler) {
  const api = new ApiIntegrface()
  api.post('/api/v1/reports', payload, callback, errhandler, null, null, true)
}

/** Auth: list reports created by the JWT user (paged: page, page_size). */
export function listMyReports(params, callback, errhandler) {
  const api = new ApiIntegrface()
  const query = {
    page: 1,
    page_size: REPORTS_PAGE_SIZE,
    ...(params && typeof params === 'object' ? params : {}),
  }
  // Back-compat: older callers passed (callback, errhandler)
  if (typeof params === 'function') {
    errhandler = callback
    callback = params
    query.page = 1
    query.page_size = REPORTS_PAGE_SIZE
  }
  api.get('/api/v1/reports', query, callback, errhandler, null, null, true)
}

/** Auth: delete report if current user is author. */
export function deleteReport(reportId, callback, errhandler) {
  const api = new ApiIntegrface()
  api.delete(
    `/api/v1/reports/${encodeURIComponent(reportId)}`,
    null,
    callback,
    errhandler,
    null,
    null,
    true
  )
}

/** Public fetch — no auth required; avoids ApiIntegrface 401 logout side-effects.
 *  Optional password via query: ?password=… (required when report.hasPassword).
 */
export function getReport(reportId, callback, errhandler, options = {}) {
  const params = {}
  if (options && options.password) {
    params.password = String(options.password)
  }
  axios({
    method: 'get',
    url: `${config.backendEndpoint}/api/v1/reports/${encodeURIComponent(reportId)}`,
    params,
    timeout: 20000,
    responseType: 'json',
    withCredentials: false,
  })
    .then((response) => {
      if (callback) callback(response.data)
    })
    .catch((error) => {
      if (errhandler) {
        errhandler(error.response || error)
      }
    })
}

export function extractReportId(res) {
  if (!res || typeof res !== 'object') return null
  return res.id || res.slug || res.code || res.report_id || res.uuid || null
}

export function normalizeReportList(res) {
  if (Array.isArray(res)) return res
  if (!res || typeof res !== 'object') return []
  if (Array.isArray(res.reports)) return res.reports
  if (Array.isArray(res.results)) return res.results
  if (Array.isArray(res.items)) return res.items
  if (Array.isArray(res.data)) return res.data
  return []
}

export function normalizeReportListPage(res, fallbackPage = 1, fallbackPageSize = REPORTS_PAGE_SIZE) {
  const reports = normalizeReportList(res)
  const count =
    res && typeof res === 'object' && typeof res.count === 'number'
      ? res.count
      : reports.length
  const pageSize = fallbackPageSize
  const totalPages = Math.max(1, Math.ceil(count / pageSize) || 1)
  const page = Math.min(Math.max(1, fallbackPage), totalPages)
  return {
    reports,
    count,
    page,
    pageSize,
    totalPages,
    hasNext: !!(res && res.next) || page < totalPages,
    hasPrevious: !!(res && res.previous) || page > 1,
  }
}
